import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { PdfFormDesignerComponent } from './components/pdf-form-designer.component';
import { MobileGestureService } from './services/mobile-gesture.service';
import { CoordinateTransformService } from './services/coordinate-transform.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    PdfViewerModule,
    PdfFormDesignerComponent
  ],
  exports: [
    PdfFormDesignerComponent
  ],
  providers: [
    MobileGestureService,
    CoordinateTransformService
  ]
})
export class PdfFormDesignerModule { }